import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import useNotify from "../unit/useNotify";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CustomButtonCancel from "./CustomButtonCancel";
import CustomButtonSave from "./CustomButtonSave";
const CustomCopyProductLinkIcon = ({ ...props }) => {
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const { successNotify, errorNotify } = useNotify();
  const handleCopyProduct = () => {
    if (props?.disabled) {
      errorNotify("Product is disabled, cannot copy");
      return;
    }
    // Handle copy product logic here
    var reqUrl = "products/actions/copyProduct";
    var response = sendRequest(reqUrl, {
      id: props?.id,
    });
    response
      .then((res) => {
        if (res.code == 200) {
          successNotify("Product #" + res.id + " copied successfully");
          refresh();
        } else {
          errorNotify("Failed to copy product");
        }
      })
      .catch((error) => {
        errorNotify("Error copying product: " + error.message);
      });
  };

  return (
    <>
      <Tooltip
        title={
          // props?.disabled
          //   ? `Can't copy this product`
          //   : `Copy Product #${props?.id}`
          props?.label || `Copy Product #${props?.id}`
        }
        placement="left"
        arrow
      >
        <IconButton
          size="small"
          // onClick={handleCopyProduct}
          onClick={() => setOpen(true)}
          sx={{ marginLeft: "5px", p: 1 }}
        >
          {props?.disabled ? (
            <ContentCopyIcon {...props} sx={{ width: "22px", color: "grey" }} />
          ) : (
            <ContentCopyIcon
              {...props}
              sx={{ width: "22px", color: "#1976d2" }}
            />
          )}
        </IconButton>
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {props?.label || "Duplicate Data"}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mt: "20px", mb: "10px" }}>
            Create a new product with the same settings.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={() => setOpen(false)} label="Cancel" />
          <CustomButtonSave onClick={handleCopyProduct} label="Confirm" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomCopyProductLinkIcon;
